<template>
    <div :class="{ constrain: showSidebar }">
        <!-- <div class='nav-bg' /> -->
        <Navigation v-if="showNav" v-model="showSidebar" />

        <div id="main" :class="{ main: showNav }">
            <!-- <transition name="opacity"> -->
            <router-view />
            <!-- </transition> -->
        </div>

        <Sidebar v-if="showSidebar" v-model="showSidebar" />
        <LogInModule v-if="hasLogin" :show="showLogInModal" />
        <Dialog />
        <NotificationModule />
        <IntercomChat />
        <Chat v-if="mountChat" />
        <MinimizedVideoChat />

        <ScrollToTop />
        <VFairHack />
        <BottomNotice v-if="showBottomConsentNotice" />
        <PortalTarget name="body" multiple />
    </div>
</template>

<script>
// Services
import AuthService from '~/services/AuthService';
import BackgroundProcessService from '~/services/BackgroundProcessesService';
import SchoolService from '~/services/SchoolService';
import WebinarMessageService from '~/services/WebinarMessageService';
import UserConsentContext, { CONSENT_IDENTIFIERS } from './services/UserConsentContext';
// Components
import Navigation from './components/navigation/Navigation';
import Sidebar from './components/navigation/Sidebar';
import LogInModule from './shared/loginmodule/LogInModule';
import NotificationModule from './components/smart/NotificationModule/NotificationModule';
import ScrollToTop from './components/miscellaneous/ScrollToTop';
import Chat from './components/chat/Chat';
import IntercomChat from './components/miscellaneous/IntercomChat';
import VFairHack from './components/miscellaneous/VFairHack.vue';
import BottomNotice from './shared/UserConsent/BottomNotice.vue';
import MinimizedVideoChat from './components/chat/MinimizedVideoChat.vue';

// Utils
import { redirectToHttps } from '~/utils/urlUtils';
import { HAS_LOGIN, HAS_CHAT, HAS_FORCED_LOGIN, IS_PROD } from '~/router';
import AnalyticService from './services/AnalyticService';
import { PortalTarget } from 'portal-vue';

export default {
    components: {
        IntercomChat,
        Chat,
        Navigation,
        Sidebar,
        LogInModule,
        NotificationModule,
        ScrollToTop,
        MinimizedVideoChat,
        VFairHack,
        BottomNotice,
        PortalTarget,
    },
    data: () => ({
        isProd: IS_PROD,

        showSidebar: false,
        blacklist: ['/login', '/recover-password', '/redirect', '/activate-user'],
        hasLogin: HAS_LOGIN,
        hasChat: HAS_CHAT,
        hasConsented: false,
        showBottomConsentNotice: !UserConsentContext.hasAnswered(),
        cookies: UserConsentContext.cookie(),
    }),
    methods: {
        cookieCallback(options) {
            if (options.name === CONSENT_IDENTIFIERS.USER_CONSENT) {
                this.showBottomConsentNotice = false;
                this.cookies.removeChangeListener(this.cookieCallback);
            }
        },
    },
    computed: {
        showNav() {
            return this.blacklist.filter(el => el === this.$route.path).length === 0;
        },
        showLogInModal() {
            return (
                this.$interfaces.logInModule.isOpen() &&
                !this.$interfaces.logInModule.getDisabledPopup()
            );
        },
        mountChat() {
            return this.hasChat && this.$interfaces.logInModule.isLoggedIn();
        },
    },
    created() {
        // Redirect to production
        if (process.env.NODE_ENV === 'production') {
            redirectToHttps();
        }
    },
    mounted() {
        // This condition is based on the fact that there is a "By continuing you accept our Terms of Service and Privacy Policy" in the register form
        if (!UserConsentContext.hasAnswered()) {
            this.showBottomConsentNotice = true;
            AnalyticService.disableGoogleAnalytics(true); // disable GA until consent is given
            this.cookies.addChangeListener(this.cookieCallback); // add listener to remove the consent notice when consent is given
        }

        // Change document title to university title
        SchoolService.initialize();

        // Initialize user-identity for logging
        if (AuthService.isAuthenticated()) {
            if (!UserConsentContext.hasAnswered()) UserConsentContext.acceptAll();
            AuthService.setIsLoggedIn(true);
        }

        if (HAS_FORCED_LOGIN) {
            // Initialize logIn popup after X amount of seconds
            BackgroundProcessService.scheduleLogInPopup();
            this.$interfaces.logInModule.setForcedLogin();
        }

        const webinarMessageService = new WebinarMessageService();
        webinarMessageService.start();
        this.$interfaces.webinarMessageModule.setService(webinarMessageService);

        // VFAIR HACK for EFMD Global VFair Event Oct 2022
        const isProduction = IS_PROD;
        fetch(
            `https://content.gethighered.global/vevent/configs/config${
                isProduction ? '' : '-dev'
            }.json`,
            {
                method: 'GET',
                headers: {},
            }
        )
            .then(res => res.json())
            .then(config => {
                const params = new URLSearchParams(window.location.search);
                // @ts-ignore
                this.$interfaces.vfairModule.setVFairHackConfig({
                    ...config,
                    redirectUrl: params.has('referrer')
                        ? decodeURIComponent(params.get('referrer'))
                        : undefined,
                });
            });
        // END VFAIR_HACK
    },
};
</script>

<style>
.main {
    margin-top: 70px;
}

@media only screen and (max-width: 1000px) {
    .main {
        margin-top: 60px;
    }
}
</style>
